import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import styled from '@emotion/styled';




function srcset(image, size, rows = 1, cols = 1) {
    return {
        src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
        srcSet: `${image}?w=${size * cols}&h=${size * rows
            }&fit=crop&auto=format&dpr=2 2x`,
    };
}

export default function Gallery() {
    return (

        <div className='row'>
            <div className='col-md-12'>

                <ImageList
                    // sx={{ width: 500, height: 450 }}
                    variant="quilted"
                    cols={4}
                    rowHeight={121}
                >
                    {itemData.map((item) => (
                        <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
                            <img
                                {...srcset(item.img, 121, item.rows, item.cols)}
                                alt={item.title}
                                loading="lazy"
                            />
                        </ImageListItem>
                    ))}
                </ImageList>

            </div>
        </div>
    );
}

const itemData = [
    {
        img: '/assets/campus/1.jpg',
        title: 'Breakfast',
        rows: 2,
        cols: 2,
    },
    {
        img: '/assets/campus/2.jpg',
        title: 'Burger',
    },
    {
        img: '/assets/campus/3.jpg',
        title: 'Camera',
    },
    {
        img: '/assets/campus/4.jpg',
        title: 'Coffee',
        rows:2,
        cols: 2,
    },
    {
        img: '/assets/campus/5.jpg',
        title: 'Hats',
        rows: 2,
        cols: 2,
    },
    {
        img: '/assets/campus/17.jpg',
        title: 'Honey',
        author: '@arwinneil',
        // cols: 2,
    },
    {
        img: '/assets/campus/13.jpg',
        title: 'Honey',
        author: '@arwinneil',
        // cols: 2,
    },
    {
        img: '/assets/campus/7.jpg',
        title: 'Basketball',
        rows:2
    },
    {
        img: '/assets/campus/8.jpg',
        title: 'Fern',
        rows:2
    },
    {
        img: '/assets/campus/6.jpg',
        title: 'Mushrooms',
        rows: 2,
        cols: 2,
    },
    {
        img: '/assets/campus/10.jpg',
        title: 'Tomato basil',
    },
    {
        img: '/assets/campus/11.jpg',
        title: 'Sea star',
    },
    {
        img: '/assets/campus/12.jpg',
        title: 'Bike',
        // cols: 2,
    },
    {
        img: '/assets/campus/14.jpg',
        title: 'Bike',
        // cols: 2,
    },
];